"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizedRoute = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AuthorizedComponent_1 = require("../AuthorizedComponent");
var AuthorizedRoute = function (_a) {
    var children = _a.children, permissions = _a.permissions, _b = _a.redirectTo, redirectTo = _b === void 0 ? '/' : _b, rest = tslib_1.__rest(_a, ["children", "permissions", "redirectTo"]);
    return (react_1.default.createElement(AuthorizedComponent_1.AuthorizedComponent, { permissions: permissions, redirectTo: react_1.default.createElement(react_router_dom_1.Redirect, { to: redirectTo }) },
        react_1.default.createElement(react_router_dom_1.Route, tslib_1.__assign({}, rest), children)));
};
exports.AuthorizedRoute = AuthorizedRoute;
//# sourceMappingURL=index.js.map